import {CREATE_PAYMENT, VERIFY_PAYMENT} from '../constants/payment';


export function createPayment(order) {
  return ({
    type: CREATE_PAYMENT,
    api: true,
    auth: true,
    payload: {
      method: 'POST',
      url: '/transactions/payments',
      data: {order}
    }
  });
}

export function verifyPayment(orderId, authority, status) {
  return ({
    type: VERIFY_PAYMENT,
    api: true,
    auth: true,
    payload: {
      method: 'PATCH',
      url: '/transactions/payments/verify',
      data: {orderId, authority, status}
    }
  });
}
